export default "__VITE_ASSET__BUwPAh5n__"